import { Injectable } from "@angular/core";
import { IFirebaseService } from "./firebase.service.interface";
import { Observable, take } from "rxjs";
import { ConfigProvider } from "src/providers/config/config";
import { initializeApp, FirebaseApp, getApp, getApps } from "firebase/app";
import { getMessaging, getToken, onMessage, Messaging,  } from "firebase/messaging";
import { Platform } from '@ionic/angular';


@Injectable()
export class FirebaseBrowserService implements IFirebaseService {
    private  VAPID_KEY = 'BN7ydksrA3_Cah7n3HwHSP2-zYgzqTAUox2nRjcVuD9siSbjwo2WiqNcRj6rs89m5eg42_HkxxPA8PSgjkYzKLk';
    private messaging: Messaging;
    private app: FirebaseApp;
    constructor(private conf:ConfigProvider, private platform: Platform) {
        console.log('Firebase Browser Service initialized');
        if(this.platform.is('desktop') || this.platform.is('mobileweb') || this.platform.is('pwa')){
            if (getApps().length<=0) {
                this.app = initializeApp(this.conf.getFirebaseConfig());
            } else {
                this.app = getApp();
            }

            this.messaging = getMessaging(this.app);
            console.log('Browser messaging', this.messaging)
        }else{
            console.log('Ionic app doesnt support service worker')
        }
    }

    async getToken(): Promise<string> {
        try {            
            if (Notification.permission !== 'granted') {
                console.warn('No permission → cannot get token');
                return "";
            }
            if ('serviceWorker' in navigator) {
                const registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js');
                const token = await getToken(this.messaging, {
                    vapidKey: this.VAPID_KEY,
                    serviceWorkerRegistration:  registration
                });
                console.info('Firebase token:', token);
                return token!;
            }else{
                console.warn('No service worker support')
                return ""
            }
        } catch (error) {
            console.error('Browser token error:', error);
            throw error;
        }
    }

    onMessageReceived(): Observable<any> {
        console.log('Browser onMessageReceived', this.messaging)
        return new Observable((observer) => {
            onMessage(this.messaging, (payload) => {
                console.log('Message received in foreground:', payload);
                observer.next(payload);
            });
        });
    }

    onTokenRefresh(): Observable<string> {
        return new Observable((observer) => {
            const checkToken = async () => {
                try {
                    const token = await getToken(this.messaging, {
                        vapidKey: this.VAPID_KEY,
                        serviceWorkerRegistration: await navigator.serviceWorker.ready
                    });
                    if (token) observer.next(token);
                } catch (err) {
                    console.error('Token refresh error', err);
                }
            };
            checkToken();
            const interval = setInterval(checkToken, 60 * 60 * 1000);
            return () => clearInterval(interval);
        });
    }

    async grantPermission(): Promise<boolean> {
        const permission = await Notification.requestPermission();
        return permission === 'granted'
    }

    async hasPermission(): Promise<boolean> {
        if (typeof Notification === 'undefined') {
            console.warn('Notifications not supported in this environment');
            return true;
        }
        return Notification.permission === 'granted' || Notification.permission === 'default';
    }
}